(function () {

    'use strict';

    angular.module('FotocApp')

        .component('fotoload', {

            templateUrl: (USE_TEMPLATE_CACHE ? '' : window.BASE_PATH + '../../src/') + 'editor/utils/fotoload.component.html',
            bindings: {
                src: '<',
                color: '<',
            },
            controller: ['$scope', '$editorService', '$canvasService', function ($scope, $editorService, $canvasService) {

                var self = this;
                self.BASE_PATH = window.BASE_PATH;
                this.loading = true;
                this.$editorService = $editorService;

                this.$onInit = function () {

                    if (angular.isDefined(this.src)) {
                        load(this.src);
                    }

                }

                this.$onChanges = function () {
                    if (angular.isDefined(this.src)) {
                        load(this.src);
                    }
                }

                function load() {

                    if (self.src !== null) {
                        self.loading = true;
                        self.image = new Image();
                        self.image.onload = function () {
                            self.loading = false;
                            $scope.$apply();
                        };
                        self.image.src = self.src;
                    }

                }

            }]


        })

})(); 